const cardText = (lastForNumbers) => {
  return `XXXX XXXX XXXX ${lastForNumbers}`;
};

module.exports = {
  cardText,
};
